import { useState, useEffect } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Star } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const ROLE = { titolare: "Titolare", amministrativo: "Amministrativo", dipendente: "Dipendente" };

export function SuperAdminRecensioni({ token }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/api/super-admin/review-stats`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setData(r.data))
      .catch(() => setData({ total: 0, per_store: {}, items: [], clicked_not_confirmed: 0 }));
  }, [token]);

  if (!data) return null;
  const stores = ["Google Play", "App Store", "Microsoft Store"];

  return (
    <Card className="mt-8" data-testid="super-admin-recensioni-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Star className="h-5 w-5 text-amber-500" />
          Recensioni dichiarate
          <span className="ml-2 text-2xl font-bold text-amber-600" data-testid="recensioni-total">{data.total}</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 gap-3 mb-4">
          {stores.map((s) => (
            <div key={s} className="rounded-lg bg-slate-50 border border-slate-200 p-3 text-center" data-testid={`recensioni-${s.toLowerCase().replace(/\s/g, "-")}`}>
              <p className="text-xs text-slate-500">{s}</p>
              <p className="text-2xl font-bold text-slate-900">{data.per_store?.[s] ?? 0}</p>
            </div>
          ))}
        </div>
        <p className="text-xs text-slate-500 mb-3">
          Utenti che hanno premuto "Sì, fatto!" dopo aver aperto lo store. Hanno aperto lo store senza confermare: <strong>{data.clicked_not_confirmed ?? 0}</strong>.
          Gli store non comunicano le recensioni effettive: il numero è dichiarato dagli utenti.
        </p>
        {data.items.length === 0 ? (
          <p className="text-sm text-slate-500" data-testid="recensioni-empty">Nessuna recensione dichiarata finora.</p>
        ) : (
          <table className="w-full text-sm" data-testid="recensioni-table">
            <thead>
              <tr className="text-left text-slate-500 border-b">
                <th className="py-2">Data</th><th>Azienda</th><th>Utente</th><th>Ruolo</th><th>Store</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((r, i) => (
                <tr key={i} className="border-b last:border-0">
                  <td className="py-2 whitespace-nowrap">{r.data ? new Date(r.data).toLocaleDateString("it-IT") : "—"}</td>
                  <td className="font-medium">{r.azienda}</td>
                  <td>{r.utente}</td>
                  <td>{ROLE[r.ruolo] || r.ruolo}</td>
                  <td>{r.store}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </CardContent>
    </Card>
  );
}
